import type { RawParams } from "@uirouter/react";
import { CRM_LIST_PAGE_ROUTE, STATIC_LIST_PAGE_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import type { ListItemDto } from "app/pages/sales-intelligence/pages/home/types/dto";
import type { CellProps } from "app/pages/sales-intelligence/pages/home/types/table";
import { OpportunityListTypeEnum } from "app/pages/sales-intelligence/sub-modules/opportunities/types";
import { getSignalId } from "../getSignalId";

export const getListPageStateParams = ({ row, field }: CellProps<ListItemDto>): [string, RawParams] => {
    const { listId, listType, crmIntegrationType, crmObjectType } = row;

    const signalsStateParams: RawParams = { signalId: getSignalId(field) };

    switch (listType) {
        case OpportunityListTypeEnum.Crm:
            return [CRM_LIST_PAGE_ROUTE, { crm: crmIntegrationType, objectType: crmObjectType, ...signalsStateParams }];

        default:
            return [STATIC_LIST_PAGE_ROUTE, { id: listId, ...signalsStateParams }];
    }
};
